export const SET_TICKETS_FILTERS = 'SET_TICKETS_FILTERS';

export const setTicketsFilters = ({ searchText, status, company, dateType, date, answered }) => ({
    type: SET_TICKETS_FILTERS,
    payload: {
        searchText,
        status,
        company,
        dateType,
        date,
        answered
    }
});
